import { api } from './client';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === 'object' && !Array.isArray(value);
}

export async function defaultQueryFn({
  queryKey,
  signal,
}: {
  queryKey: readonly unknown[];
  signal?: AbortSignal;
}) {
  const last = queryKey.at(-1);
  const hasParams = isPlainObject(last);
  const segments = hasParams ? queryKey.slice(0, -1) : queryKey;
  const params = hasParams ? last : undefined;
  if (segments.some(s => s == null)) {
    throw new Error(`queryKey contains null/undefined segments: [${queryKey.join(', ')}]`);
  }
  const path = segments.map(String).join('/');
  const { data } = await api.get(path, params, { signal, fromReactQuery: true });
  return data;
}
